import React, { useState } from "react";
import { Collapse } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { ChevronDown } from "react-feather";
import Results from "./Results";
import {
  Head,
  HeadLeft,
  HeadRight,
  BodyLeft,
  BodyRight,
  Wrapper,
  BodyItem,
  Body,
  OptionsWrapper,
  HighlightColor,
  SecondaryColor,
} from "./styles";

const options = {
  maintainAspectRatio: false,
  responsive: true,
  cornerRadius: 2,
  indexAxis: "y",
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: () => "",
        beforeBody: (c) => `${c[0].raw} submissions`,
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        color: "black",
      },
      title: {
        display: false,
        text: "Count",
      },
    },

    x: {
      title: {
        display: true,
        text: "Total Submitted",
      },
      ticks: {
        color: "black",
      },
    },
  },
};

const getStats = (question) => {
  const correctAnswer = question?.correct_answer.join(",");

  const correctAnswers = question.answer_distribution[correctAnswer] || 0;
  const totalAnswers = Object.values(question.answer_distribution).reduce(
    (a, b) => (b += a),
    0,
  );

  return {
    correctAnswer,
    totalAnswers,
    correctAnswers,
    percentageCorrect: Math.ceil((correctAnswers / totalAnswers) * 100),
  };
};

const SelectAll = ({ question }) => {
  const [open, setOpen] = useState(true);

  const numRowsInBarChart = Object.keys(question.answer_distribution).length;

  const LabelArray = Object.keys(question.answer_distribution);

  const { totalAnswers, correctAnswers, percentageCorrect, correctAnswer } =
    getStats(question);

  const data = {
    labels: LabelArray.map((label) => label.toUpperCase()),
    datasets: [
      {
        label: "Submitted Options",
        data: Object.values(question.answer_distribution),
        barPercentage: 0.5,
        borderRadius: 2,
        minBarLength: 2,
        borderWidth: 1,
        backgroundColor: LabelArray.map((label) =>
          label === correctAnswer ? HighlightColor : SecondaryColor,
        ),
        borderColor: "black",
        categoryPercentage: 0.9,
      },
    ],
  };

  return (
    <Wrapper $isOpen={open}>
      <Head onClick={() => setOpen((p) => !p)}>
        <HeadLeft>
          <span style={{ fontWeight: "600", fontSize: 12, color: "black" }}>
            Question {question.order + 1}
            <span
              style={{ color: "darkgrey", fontWeight: "400", paddingLeft: 2 }}
            >
              (Select All)
            </span>
          </span>
          <span
            style={{
              fontSize: 15,
              fontWeight: "400",
              color: "black",
              textAlign: "left",
            }}
          >
            {question?.question}
          </span>
        </HeadLeft>

        <HeadRight $isOpen={open}>
          <ChevronDown color="black" />
        </HeadRight>
      </Head>
      <Collapse in={open}>
        <Body>
          <BodyItem style={{ background: "white" }}>
            <span style={{ fontWeight: "500" }}>Options</span>
            <OptionsWrapper>
              {Object.entries(question?.options).map(([a, b]) => (
                <div
                  key={a}
                  style={{
                    width: "100%",
                    borderBottom: "1px solid #eeeeee",
                    background: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: 8,
                    borderRadius: 0,
                    padding: "4px",
                  }}
                >
                  <div
                    style={{
                      height: 20,
                      width: 20,
                      borderRadius: 10,
                      background: question.correct_answer.includes(a)
                        ? HighlightColor
                        : SecondaryColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span
                      style={{
                        textTransform: "uppercase",
                        color: "white",
                        fontWeight: "600",
                      }}
                    >
                      {a}
                    </span>
                  </div>

                  <span>{b}</span>
                </div>
              ))}
            </OptionsWrapper>
          </BodyItem>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <BodyLeft>
              <span style={{ fontWeight: "500" }}>Responses Breakdown</span>
              <div
                style={{
                  height: numRowsInBarChart * 34,
                  width: "100%",
                  minHeight: 180,
                }}
              >
                <Bar options={options} data={data} />
              </div>
            </BodyLeft>

            <BodyRight>
              <Results
                totalAnswers={totalAnswers}
                correctAnswers={correctAnswers}
                percentageCorrect={percentageCorrect}
              />
            </BodyRight>
          </div>
        </Body>
      </Collapse>
    </Wrapper>
  );
};

export default SelectAll;

//  This looks good, just not sure where it fits rn //*
// <div
//   style={{
//     display: "flex",
//     alignItems: "center",
//     gap: 2,
//     alignSelf: "center",
//   }}
// >
//   <OptionWrapSmall iscorrect="N">
//     <span>A</span>
//   </OptionWrapSmall>
//   <OptionDividerSmall />
//   <OptionWrapSmall iscorrect="Y">
//     <span>B</span>
//   </OptionWrapSmall>
//   <OptionDividerSmall />
//   <OptionWrapSmall iscorrect="Y">
//     <span>C</span>
//   </OptionWrapSmall>
//   <OptionDividerSmall />
//   <OptionWrapSmall iscorrect="N">
//     <span>D</span>
//   </OptionWrapSmall>
// </div>
